import { ListingDetailsPage } from 'listing-details';

export default ListingDetailsPage;
